import { render, staticRenderFns } from "./Staging-New-Request-Step3.vue?vue&type=template&id=99cb8c8c&scoped=true&"
import script from "./Staging-New-Request-Step3.vue?vue&type=script&lang=js&"
export * from "./Staging-New-Request-Step3.vue?vue&type=script&lang=js&"
import style0 from "./Staging-New-Request-Step3.vue?vue&type=style&index=0&id=99cb8c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cb8c8c",
  null
  
)

export default component.exports